import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/apiClient";

export default function Login() {
  const { login, user, checked } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (checked && user) navigate("/admin", { replace: true });
  }, [checked, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Accesso non riuscito");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-beige px-6" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Logo size="text-3xl" />
          <p className="mt-2 text-xs uppercase tracking-[0.25em] text-ink/40">Pannello amministrazione</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-[0_4px_24px_rgba(0,0,0,0.06)] space-y-5" data-testid="login-form">
          <div className="h-12 w-12 rounded-xl bg-coral/10 flex items-center justify-center text-coral mx-auto">
            <Lock size={22} />
          </div>
          <div>
            <label className="block text-sm font-medium text-ink mb-2">Email</label>
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="w-full rounded-xl border border-ink/15 bg-beige/40 px-4 py-3 outline-none focus:ring-2 focus:ring-coral/40 focus:border-coral transition"
              placeholder="admin@mcstudio.it"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-ink mb-2">Password</label>
            <input
              type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="w-full rounded-xl border border-ink/15 bg-beige/40 px-4 py-3 outline-none focus:ring-2 focus:ring-coral/40 focus:border-coral transition"
              placeholder="••••••••"
            />
          </div>
          {error && <p className="text-coral text-sm" data-testid="login-error">{error}</p>}
          <button
            type="submit" disabled={loading}
            data-testid="login-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-coral text-white rounded-full px-8 py-3.5 font-semibold hover:bg-[#e04047] transition-colors disabled:opacity-60"
          >
            {loading ? <><Loader2 size={18} className="animate-spin" /> Accesso...</> : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
